import { Menu } from "antd";
import { useLocation } from "react-router-dom";
import items, { pathToKey } from "./sideMenuItems";

export default function SideMenu() {
  const { pathname } = useLocation();
  const selectedKey = pathToKey[pathname] ?? pathToKey[Object.keys(pathToKey).find(p => p !== "/" && pathname.startsWith(p)) ?? ""] ?? "1";

  return (
    <>
      <style>{`
        .side-menu.ant-menu-dark {
          background: transparent;
        }
        .side-menu.ant-menu-dark .ant-menu-item {
          height: 36px;
          line-height: 36px;
          margin: 2px 8px;
          width: calc(100% - 16px);
          border-radius: 6px;
          padding: 0 12px !important;
          font-size: 13px;
          color: rgba(255,255,255,0.65);
          transition: background 0.15s;
        }
        .side-menu.ant-menu-dark .ant-menu-item:hover {
          background: rgba(255,255,255,0.08) !important;
          color: rgba(255,255,255,0.9);
        }
        .side-menu.ant-menu-dark .ant-menu-item-selected {
          background: rgba(255,255,255,0.12) !important;
          color: #fff;
        }
        .side-menu.ant-menu-dark .ant-menu-submenu-title {
          height: 36px;
          line-height: 36px;
          margin: 2px 8px;
          width: calc(100% - 16px);
          border-radius: 6px;
          padding: 0 12px !important;
          font-size: 13px;
          color: rgba(255,255,255,0.65);
        }
        .side-menu.ant-menu-dark .ant-menu-submenu-title:hover {
          background: rgba(255,255,255,0.08) !important;
          color: rgba(255,255,255,0.9);
        }
        .side-menu.ant-menu-dark .ant-menu-sub {
          background: transparent !important;
        }
        .side-menu.ant-menu-dark .ant-menu-sub .ant-menu-item {
          padding: 0 12px 0 36px !important;
          font-size: 12px;
          color: rgba(255,255,255,0.5);
        }
        .side-menu.ant-menu-dark .ant-menu-sub .ant-menu-item-selected {
          color: rgba(255,255,255,0.9);
          background: rgba(255,255,255,0.10) !important;
        }
        .side-menu .ant-menu-item .anticon,
        .side-menu .ant-menu-submenu-title .anticon {
          font-size: 15px;
          min-width: 15px;
        }
        /* Add gap between icon and label */
        .side-menu .ant-menu-title-content {
          margin-left: 10px;
        }
        .side-menu a {
          color: inherit !important;
        }
      `}</style>
      <Menu
        className="side-menu"
        selectedKeys={[selectedKey]}
        mode="inline"
        theme="dark"
        items={items}
      />
    </>
  );
}